import React from 'react';

import offerEnvelope from 'images/referral/offer_envelope.svg';

import { PLAN_TYPE_MONTHLY } from '../../../src/constants';
import { TIModal } from '../../BaseUI';
import LinkCopy from '../../BaseUI/LinkCopy';
import styles from './styles.module.scss';

const Modal = ({
  isOpen,
  onClose,
  referralUrl,
  currentUserPlanType,
}: {
  isOpen: boolean;
  onClose: () => void;
  referralUrl: string;
  currentUserPlanType?: string;
}) => {
  return (
    <TIModal
      isOpen={isOpen}
      onClose={onClose}
      parentClass={styles.referralModal}
      customHeader={true}
    >
      <div className={styles.topHeaderContainer}>
        <div className={styles.topHeader}>
          <div className={styles.header}>
            The Information is better when friends &#38; colleagues <strong>read together</strong>
          </div>
        </div>
        <button className="close-button" onClick={onClose}></button>
      </div>
      <div className={styles.mainContainer}>
        <div className={styles.giftContainer}>
          <img src={offerEnvelope} width={25} height={25} />
        </div>
        <div className={styles.intro}>
          As a benefit of your subscription, you can give 25% off access to The Information.
        </div>
        <div className={styles.subIntro}>
          Share this custom offer link with friends and colleagues. They save 25%, and you get $50
          for every person that signs up*
        </div>
        <div className={styles.customLink}>Your custom invite link</div>
        <div className={styles.linkWrapper}>
          <LinkCopy
            clipboardLink={referralUrl}
            customClass={styles.linkContainerOverride}
            trackingProps={{
              'ahoy-name': 'Referral Modal - Click On Copy Referral Link',
              location: 'referral_modal',
              name: 'copy_referral_link',
            }}
          />
        </div>
        {currentUserPlanType !== PLAN_TYPE_MONTHLY && (
          <div className={styles.disclosure}>
            *For new annual subscription only. Payouts will be made a month after sign-up and are
            paid through Venmo or PayPal
          </div>
        )}
      </div>
    </TIModal>
  );
};

export default Modal;
